import { IconButton } from "@/design-system/IconButton/IconButton";
import { cn } from "@/lib/utils";
import { t } from "@repo/shared/i18n";
import React, { useState } from "react";

import { filter as filterIcon } from "../../../../../icons";

type FilterButtonProps = {
  onClick: () => void;
  numberOfFilters?: number;
  label?: string;
};

export const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  numberOfFilters = 0,
  label,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div className="flex flex-col gap-y-1">
      {label && (
        <span
          className={cn(
            "text-xs h-8 flex justify-center items-end text-center select-none",
            !hover && "brightness-75",
          )}
        >
          {label}
        </span>
      )}
      <div className="relative w-fit">
        <IconButton
          icon={<span className="size-5">{filterIcon}</span>}
          className="text-icon"
          aria-label={t("common:filters")}
          onClick={(e) => {
            onClick();
            e.stopPropagation();
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        />
        {/* Count only; clearing lives in the filters panel */}
        {numberOfFilters > 0 && (
          <div className="absolute -right-2 -top-2 w-5 h-5 text-sm font-bold text-center text-white rounded-full bg-primary-blue pointer-events-none">
            {numberOfFilters}
          </div>
        )}
      </div>
    </div>
  );
};
